import React, { useEffect, useState } from "react";
import { API } from "./../../config/api";
export default function ContactMsg() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const res = await fetch(API.CONTACT);

      const data = await res.json();

      setMessages(data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  return (
    <div className="dashboard-content">
      <h2 className="machine-title">Contact Messages</h2>

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Details</th>

              <th>Subject</th>

              <th>Message</th>
            </tr>
          </thead>

          <tbody>
            {messages.length > 0 ? (
              messages.map((item, index) => (
                <tr key={item.id}>
                  <td data-label="#">{messages.length - index}</td>
                  <td>
                    {new Date(item.created_at).toLocaleDateString("en-GB")}
                  </td>
                  <td>
                    <div className="fw-bold">{item.name}</div>
                    <div className="text-muted small">{item.phone}</div>
                    <div className="text-muted small">{item.email}</div>
                  </td>

                  <td data-label="Subject">{item.subject}</td>

                  <td data-label="Message" style={{ minWidth: "400px" }}>
                    {item.message}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No Messages Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
